module.exports = __webpack_public_path__ + "static/media/A2_18.fdb9b727.png";